import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MenuItem, SortEvent } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Versions, Viewdata, GlobalMessage } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { HelpmasterService } from './helpmaster.service';
import { HelpmastermodalComponent } from '../../directives/helpmastermodal/helpmastermodal.component';
import { ExceldownloadComponent } from '../../directives/exceldownload/exceldownload.component';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
@Component({
  selector: 'app-helpmaster',
  templateUrl: './helpmaster.component.html',
  styleUrls: ['./helpmaster.component.css']
})
export class HelpmasterComponent {

    showcount: number = 0;
    hidecount: number = 0;
    working: boolean = true;
    ref: DynamicDialogRef | undefined;
    selectedProduct = false;
    commonScrollHeight='';
    totalRecords: number = 0;
    isActivefilter=false
    options = [];
    paginatorArray=[]
    buttonOption = [];
    tab = 1;
    items: MenuItem[] | undefined;
   selectedItem: MenuItem | null = null;
    tableData: any[] = []; 
    excel_paragraph='';
    templatedownloadtext='';
    exceldownloadModal=false;
    searchText: string;
    helplist: any;
    listarray: Array<Versions>=[];
    sortOrder = 1;
    sortProperty: string = 'id';
    versionRequest: Versions = new Versions();
    versionUpdatereq: Versions = new Versions();
    versions: any;
    versionssarray: Array<Versions>;
    versiontype: any;
    versionarray: Array<Versions>=[];
    dataview: Viewdata = new Viewdata();
    buttunText="Add New"
    isButtonraised:boolean=true;
    page: number = 1;
    count: number = 0;
    tableSize: number = 10;
    tableSizes: any = [10, 20, 50, 100];
    tablecount: number = 0;
    numberofrowsintable: number = 10;
    visible:boolean=false;
    position='top';
    cols=[];
    _selectedColumns=[];
    message:GlobalMessage=new GlobalMessage()
    isEdit:boolean=false;
    activeFlag = [
      {'labelname': 'Active','value': 'Y'},
      {'labelname': 'Inactive','value': 'N'}
    ]

    constructor(
      private GenHelpHomeService: HelpmasterService,
      public router: Router,  
      public dialogService: DialogService,
      private spinner:NgxSpinnerService,
      public helpservice: PagehelpmodalService,
      private utilityservice:Utilityservice) { 
      this.excel_paragraph=this.message.downloadexcel_text;
      this.templatedownloadtext=this.message.excelformate_text
    }
    ngOnInit() {  
      this.commonScrollHeight=this.utilityservice.updateScrollHeight();
      console.log(this.commonScrollHeight);
      this.gettabledata();
      this.dynamiccols(); 
    }
  
    onMenuItemClick(event: any): void {
      this.selectedItem = event.item;
      if (this.selectedItem.command) {
        this.selectedItem.command();
      }
    }
  
    @HostListener('window:resize', ['$event'])
    onResize() {
    this.commonScrollHeight=this.utilityservice.updateScrollHeight();
  }
  
  dynamiccols(){
    this.cols=[
      { field: "productid", header: "Product ID",type:'text',sort: true ,filter:true, width:'15px',isChecked:true,class:'otherheader' }, 
      {field:'productinitial',header:'Product Name',type:'text',sort: true , filter:true, width:'7px !important',isChecked:true, class:'headerid'},
      { field: "rid", header: "Module Help ID",type:'text',sort: true , filter:true, width:'px', isChecked:true,class:'otherheader' } ,
      { field: "topic", header: "Help Topic",type:'text',sort: true , filter:true, width:'60px', isChecked:true,class:'otherheader' } ,
      { field: "sequence", header: "Sequence",type:'text',sort: true , filter:true, width:'15px  !important', isChecked:true } ,
      { field: "adminflag", header: "Admin Topic",type:'text',sort: true , filter:false, width:'15px',isChecked:true,class:'otherheader' }, 
      { field: "activeflag", header: "Status",type:'text',sort: true , filter:false, width:'15px',isChecked:true,class:'otherheader' }, 
      { field: "firstname", header: "Created By",type:'text',sort: true , filter:false, width:'15px',isChecked:true,class:'otherheader' }, 
      { field: "createdon", header: "Created On",type:'text',sort: true , filter:false, width:'30px  !important',isChecked:true,class:'otherheader' } 
    ]
   this._selectedColumns = this.cols;
  }
    
    gettabledata() {
      this.GenHelpHomeService.gettabledata().subscribe((data) => {
        this.helplist = data;
        this.listarray = this.helplist;
        this.options=  this.GenHelpHomeService.getOptionDropdown(data.length);
        this.paginatorArray=this.options.map(e=>e.value)
        this.listarray.map(e=>{
          e['isSelect']=false
        }) 
        this.totalRecords=this.listarray.length;
        this.tablecount = this.helplist.count;
      });
    }
  
    handlePageChange(event: any) {
      this.numberofrowsintable=event.rows
    }
  
    filedata:any=[]
    setEvent(event){ this.filedata=event}
    handleDialogClose() {this.filedata = [];}    
  
      customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
        let value1 = data1[event.field];
        let value2 = data2[event.field];
        let result = 0;

        // Handling null values
        if (value1 == null && value2 != null) return -1;
        if (value1 != null && value2 == null) return 1;
        if (value1 == null && value2 == null) return 0;

        // Check if the field is createdon for date comparison
        if (event.field === 'createdon') {
            // Parse the date strings to Date objects
            const date1 = new Date(value1);
            const date2 = new Date(value2);
            return date1.getTime() - date2.getTime(); // Sort by timestamp
        }

        // Handle string comparisons
        if (typeof value1 === 'string' && typeof value2 === 'string') {
            return value1.trim().toLowerCase().localeCompare(value2.trim().toLowerCase());
        }

        // Fallback to default number comparison for other types
        return (value1 < value2 ? -1 : (value1 > value2 ? 1 : 0));
    });
    
    return event.order === -1 ? event.data.reverse() : event.data; // Reverse if descending
}

    
  show(title, data) {
    let details = {};
    if (title === 'Modify') {
      this.spinner.show();
      this.GenHelpHomeService.gethelpbyid(data.rid).subscribe((res: any) => {
        this.spinner.hide();
        if (res.length === 0) {
          const timestamp = new Date().toLocaleString(); // example timestamp
      Swal.fire({
        title: 'Data Not Found',
        text: `This event occurred at: ${timestamp}`,
        icon: 'error'
      })
        } else {
          details = res;
          this.ref = this.dialogService.open(HelpmastermodalComponent, {
            header: 'Modify Help Item',
            width: '90vw',
            height:'90%',
            data:{title:title,datas:details},
            contentStyle: { overflow: 'hidden' },
            maximizable: true,
          });
          this.ref.onClose.subscribe(() => {            
            this.gettabledata();
          });
        }
      },error=>{
        this.spinner.hide();
            const timestamp = new Date().toLocaleString(); // example timestamp
      Swal.fire({
        title: error.error.error,
        text: `This event occurred at: ${timestamp}`,
        icon: 'error'
      })

      });
    } else {
      details = {};
      this.ref = this.dialogService.open(HelpmastermodalComponent, {
        header: title,
        width: '90vw',
        height:'90%',
        data: { title: title, datas: details },
        contentStyle: { overflow: 'auto', },
        maximizable: true,
      });
      this.ref.onClose.subscribe(() => {
        this.gettabledata();
      });
    }
  }

  
    viewData(data) {
      this.GenHelpHomeService.getview(data.rid).subscribe(res => {
        this.ref = this.dialogService.open(HelpmastermodalComponent, {
          header: 'View Help Item',
            width: '90vw',
            height:'90%',
          data: { title: 'View Help Item', datas: res },
          // contentStyle: { overflow: 'hidden'  },
          baseZIndex: 10000,
          maximizable: true,
        });
      },error=>{
        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error.error,
          text: `This event occurred at: ${timestamp}`,
          icon: 'error'
        })
      })
    }
  
  //Download Version Master Excel
    downloadgridexcel() {
      this.GenHelpHomeService.dataExcel().subscribe((response: Blob) => {
        const blob = new Blob([response],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Help Master.xlsx';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        this.exceldownloadModal=false;
      }, () => {
        Swal.fire('Something went wrong', '', 'error');
  
      })
        ;
    }
  
    exceDownloadModel() {
      let payload = {}
      this.ref = this.dialogService.open(ExceldownloadComponent, {
        header: "Excel Download",
        width: '44vw',
        height: '10vw',
        data: {
          excelname: "Help Master.xlsx", downloadapi: 'common/help/dataexcel',
          method: 'get', message: this.excel_paragraph, payload: payload
        },
        contentStyle: { overflow: 'hidden' },
        position: 'center'
  
      })
    }
  
  searchTerm: string = ''; 
  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }

}
